import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApresentacaoService } from '../../services/apresentacao.service';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Apresentacao, PfIndicator, PfIndTable } from '../../models/apresentacao.model';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../../services/shared.service';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Agency } from '../../models/itens.model';

@Component({
  selector: 'app-apresentacao-quadro-geral',
  templateUrl: './apresentacao-quadro-geral.component.html',
  styleUrls: ['./apresentacao-quadro-geral.component.scss']
})
export class ApresentacaoQuadroGeralComponent extends BaseFormComponent<Apresentacao> implements OnInit, AfterViewInit  {
  id:number;
  filters: any;
  currentFilter: any;
  statusFile: any = this.setFilePath('duration.svg');
  statusProjection: any = this.setFilePath('flag.svg');
  currentPage: string = 'status';
  polar= {'1':'Se maior, melhor', '3':'Se menor, melhor'};
  statusChart = null;
  achievementChart = [];
  projectionChart = [];
  statusLabel = null;
  agencies = null;
  patternProjection = null;
  patternAchievement = null;
  @Input() print:boolean = false;
  
  
  @ViewChild('baseChart') chart: any;
  @Output() graficoCarregado = new EventEmitter<void>();

  constructor(
    public activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    public myService: ApresentacaoService,
    private apresentacaoResolverId: ApresentacaoResolverId,
    private sanitizer: DomSanitizer,
  ) {
    super(activatedRoute); 
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }
  
  ngAfterViewInit(): void {
    if(this.print){
      setTimeout(() => {
        const charts = document.querySelectorAll('.chart-item');
        const promises: Promise<void>[] = [];
        charts.forEach((elemento: HTMLCanvasElement, index) => {
          console.log(elemento)
          if(index != 0){
            const chartInstance = Chart.getChart(elemento as HTMLCanvasElement);
            chartInstance.resize(220, 40);
          }
          const promise = this.getChartImage(elemento).then((dataUrl) => {
            const img = document.getElementById('img_' + elemento.id) as HTMLImageElement;
            if (img && dataUrl) {
              img.src = dataUrl;
              elemento.remove();
            }
          });
      
          promises.push(promise);
        });
        Promise.all(promises).then(() => {
          this.graficoCarregado.emit();
        });
      }, 1000);
    }
    else{
      var canvas = document.getElementById('chart1');
      const chartInstance = Chart.getChart(canvas as HTMLCanvasElement);
      chartInstance.resize(); 
    }
  }
  ngAfterViewChecked() {
    var canvas = document.getElementById('chart1');
    const chartInstance = Chart.getChart(canvas as HTMLCanvasElement);
    if(chartInstance){
      chartInstance.resize();
    }
  }

  start(){
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.filters = data.filters;
          this.currentFilter = data.currentFilter;
          var gData = data.graphData;
          this.statusChart = this.getGraphStatusData(gData.statusData, 'Status dos Projetos');
          this.statusLabel = this.getGraphStatusLabel(gData.statusData);
          this.agencies = this.sharedService.filterData(this.currentFilter, gData.agenciesStatusData);
          var achievementData = this.sharedService.filterData2(this.currentFilter, gData.achievementData.agency);
          this.achievementChart = this.sharedService.getGraphGoalData(achievementData, this.sharedService.patternAchievement, this.print);
          
          this.patternAchievement = this.sharedService.patternAchievement.map( p =>
            {
              p['label'] = gData.achievementData.labels[p.id]['label']
              return p;
            }
          );
          
          var projectionData = this.sharedService.filterData2(this.currentFilter, gData.projectionData.agency);
          this.projectionChart = this.sharedService.getGraphGoalData(projectionData, this.sharedService.patternProjection, this.print);
          this.patternProjection = this.sharedService.patternProjection.map( p =>
            {
              p['label'] = gData.projectionData.labels[p.id]['label']
              return p;
            }
          );
          
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
  }


  setFilePath(filePath: string) {
    const fullPath = `assets/images/svgs/${filePath}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullPath);
  }
  
  getGraphStatusData(data, title){
    var chartData  = {
      labels: [],
      datasets: [],
    };
    var datasets  = { 
      label: title,
      data: [],
      backgroundColor: [],
      borderColor: 'rgba(255, 255, 255, 1)', 
      borderWidth: 6 
    };
    const doughnutLabelsLine = {
      id: 'doughnutLabelsLine',
      afterDraw(chart, args, options) {
        const { ctx, chartArea: { top, bottom, left, right, width, height } } = chart;
        chart.data.datasets.forEach((dataset, i) => {
          chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
            const { x, y } = datapoint.tooltipPosition();
            const offset = 50;  // distancia das linhas
    
            // desenha linha
            const halfwidth = width / 2;
            const halfheight = height / 2;
    
            const xLine = x >= halfwidth ? x + offset : x - offset;
            const yLine = y >= halfheight ? y + offset : y - offset;
            const extraLine = x >= halfwidth ? offset : -offset;
            const baseStartX = x >= halfwidth  ? x + 20 : x - 20;
            const baseStartY = y >= halfheight ? y + 20 : y - 20;
    
            ctx.beginPath();
            ctx.moveTo(baseStartX, baseStartY);
            ctx.lineTo(xLine, yLine);
            ctx.lineTo(xLine + extraLine, yLine);
            ctx.strokeStyle = dataset.borderColor[index];
            ctx.stroke();
            // desenha texto
            const totalData = chart.data.datasets[0].data.reduce((acc, val) => acc + val, 0);
            const value = dataset.data[index];
            const percentage = ((value / totalData) * 100).toFixed(2);
            const labelText = `${value} (${percentage}%)`;
            const textWidth = ctx.measureText(labelText).width;
            ctx.font = '1em Arial';
    
            const textXPosition = x >= halfwidth ? 'left' : 'right';
            const plusFivePx = x >= halfwidth ? 5 : -5;
            const textAlign = textXPosition;
    
            ctx.textAlign = textAlign;
            ctx.textBaseline = 'middle';
            ctx.fillStyle = dataset.borderColor[index];
            ctx.fillText(labelText, xLine + extraLine + plusFivePx, yLine);
          });
        });
      }
    };
    this.sharedService.patternStatus.forEach(p => {
      var l = data.labels[p.id];
      if(l){
        var filterData = this.sharedService.filterData(this.currentFilter, l?.agency ?? {});
        var total = Object.values(filterData).reduce((acc:number, item:number) => acc + item['total'], 0);
        chartData['labels'].push(l.label);
        datasets['data'].push(total);
        datasets['backgroundColor'].push(p.color);
      }
    });
    chartData['datasets'].push(datasets);
    
    var chart = {
      type: 'doughnut',
      data: chartData,
      zoomOutPercentage: 30,
      aspectRatio: 1,
      options:{
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
        }
      },
      plugins: [ doughnutLabelsLine]
    }
    
    //Chart.register(doughnutLabelsLine);
    return chart;
  }
  getGraphStatusLabel(data){
    var result = [];
    var filteredData = Object.entries(data.labels)?.reduce((acc, [key, l]) => {
      l['agency'] = this.sharedService.filterData(this.currentFilter, l['agency']);
      l['total'] = Object.values(l['agency']).reduce((acc:number, item:number) => acc + item['total'], 0);
      acc[key] = l;
      return acc;
    }, {});
    var total = Object.values(filteredData).reduce((acc, item) => acc + item['total'], 0);
    this.sharedService.patternStatus.forEach(function(p) {
      var l = filteredData[p.id];
      if(l && l.total > 0){
        var item = {};
        item['label'] = l.label;
        item['qtd'] = l.total;
        item['percent'] = +l.total / +total;
        item['backgroundColor'] = p.color;
        result.push(item);
      }
    });
    return result;
  }

  countDataChart(item){
    var total = 0;
    item.datasets.forEach(d => {
      total += d?.data[0] ?? 0;
    });
    return total;
  }
  getChartImage(canvas: HTMLCanvasElement): Promise<string> {
    return new Promise((resolve) => {
      if (canvas) {
        try {
          const dataURL = canvas.toDataURL('image/png');
          console.log(dataURL)
          resolve(dataURL);
        } catch (error) {
          console.log(error)
          resolve(null);
        }
      }
    });
  }
  changePage(page:string): void{
    this.currentPage = page;
  }

  getTotalProjects(){
    var listAgencies = Object.values(this.agencies ?? {});
    const sum = listAgencies?.reduce(function(a, b){
        return a + (b['total'] ?? 0);
    }, 0);
    return sum;
  }
  orderAgencies(){
    var listAgencies:Agency[] = Object.values(this.agencies ?? {}) ;
    const sortData = listAgencies.sort((a, b) => {
      if (a.nro_ord_parent === b.nro_ord_parent) {
        return a.nro_ord_child - b.nro_ord_child;
      }
      return a.nro_ord_parent - b.nro_ord_parent;
    });
    return sortData;
  }
}
